import React from "react";
import {
  Container,
  Row,
  Col,
  Button,
  FormFeedback,
  Form,
  Input,
  Label,
} from "reactstrap";
import * as Yup from "yup";
import { useFormik } from "formik";
import api from "../../services/api";

const ContactUs = () => {
  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      name: "",
      email: "",
      subject: "",
      message: "",
    },
    validationSchema: Yup.object({
      name: Yup.string().required("Please enter your name"),
      email: Yup.string()
        .email("Please enter a valid email")
        .required("Please enter your email"),
      subject: Yup.string().required("Please enter your subject"),
      message: Yup.string().required("Please enter your message"),
    }),
    onSubmit: async (values, { resetForm, setSubmitting }) => {
  try {
    const response = await api.post("/contact", values);

    alert(response.data.message || "Message sent successfully.");

    resetForm();
  } catch (error) {
    console.error("Contact form error:", error);

    alert(
      error.response?.data?.message ||
      "Unable to send your message. Please try again."
    );
  } finally {
    setSubmitting(false);
  }
},
  });

  return (
    <section className="pwlp-contact-section" id="contact">
      <Container>
        <Row className="justify-content-center">
          <Col lg="8" className="text-center">
            <h2 className="pwlp-contact-section__title">Get in Touch</h2>
            <p className="pwlp-contact-section__desc">
              Have questions about PayWeek? Our team is here to help you find
              the right solution for your business.
            </p>
          </Col>
        </Row>

        <Row className="justify-content-center">
          <Col lg="8" xl="7">
            <div className="pwlp-contact-card">
              <Form
                onSubmit={(e) => {
                  e.preventDefault();
                  validation.handleSubmit();
                  return false;
                }}
              >
                <div className="pwlp-contact-field">
                  <Label htmlFor="name" className="pwlp-contact-label">
                    Name <span>*</span>
                  </Label>
                  <Input
                    id="name"
                    name="name"
                    type="text"
                    placeholder="John Doe"
                    className="pwlp-contact-input"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.name}
                    invalid={
                      validation.touched.name && !!validation.errors.name
                    }
                  />
                  {validation.touched.name && validation.errors.name ? (
                    <FormFeedback>{validation.errors.name}</FormFeedback>
                  ) : null}
                </div>

                <div className="pwlp-contact-field">
                  <Label htmlFor="email" className="pwlp-contact-label">
                    Email ID <span>*</span>
                  </Label>
                  <Input
                    id="email"
                    name="email"
                    type="email"
                    placeholder="john@company.com"
                    className="pwlp-contact-input"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.email}
                    invalid={
                      validation.touched.email && !!validation.errors.email
                    }
                  />
                  {validation.touched.email && validation.errors.email ? (
                    <FormFeedback>{validation.errors.email}</FormFeedback>
                  ) : null}
                </div>

                <div className="pwlp-contact-field">
                  <Label htmlFor="subject" className="pwlp-contact-label">
                    Subject <span>*</span>
                  </Label>
                  <Input
                    id="subject"
                    name="subject"
                    type="text"
                    placeholder="How can we help?"
                    className="pwlp-contact-input"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.subject}
                    invalid={
                      validation.touched.subject && !!validation.errors.subject
                    }
                  />
                  {validation.touched.subject && validation.errors.subject ? (
                    <FormFeedback>{validation.errors.subject}</FormFeedback>
                  ) : null}
                </div>

                <div className="pwlp-contact-field">
                  <Label htmlFor="message" className="pwlp-contact-label">
                    Message <span>*</span>
                  </Label>
                  <Input
                    id="message"
                    name="message"
                    type="textarea"
                    rows="6"
                    placeholder="Tell us about your company's needs"
                    className="pwlp-contact-input pwlp-contact-textarea"
                    onChange={validation.handleChange}
                    onBlur={validation.handleBlur}
                    value={validation.values.message}
                    invalid={
                      validation.touched.message && !!validation.errors.message
                    }
                  />
                  {validation.touched.message && validation.errors.message ? (
                    <FormFeedback>{validation.errors.message}</FormFeedback>
                  ) : null}
                </div>

                <Button
  type="submit"
  className="pwlp-contact-submit"
  disabled={validation.isSubmitting}
>
  {validation.isSubmitting ? "Sending..." : "Send message"}
</Button>
              </Form>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default ContactUs;


// import React from "react";
// import { Container, Row, Col, Button, FormFeedback, Form, Input } from "reactstrap";

// // Formik validation
// import * as Yup from "yup";
// import { useFormik } from "formik";

// //Import Section Title
// //port SectionTitle from "../common/section-title";

// const ContactUs = () => {
//   const validation = useFormik({
//     // enableReinitialize : use this flag when initial values needs to be changed
//     enableReinitialize: true,

//     initialValues: {
//         name: '',
//         email: '',
//         subject: '',
//     },
//     validationSchema: Yup.object({
//         name: Yup.string().required("Please Enter Your Name"),
//         email: Yup.string().required("Please Enter Your Email"),
//         subject: Yup.string().required("Please Enter Your Subject"),
//     }),
//     onSubmit: (values) => {
//         console.log("values",values);
//     }
// });
//     return (
//       <React.Fragment>
//         <section className="section " id="contact">
//           <Container>
//           <div className="contact-section-header text-center">
//   <h1 className="section-title">Get In Touch</h1>
//   <div className="section-title-border mt-3"></div>
  
// </div>

//             <Row>
//               <Col lg="4">
//                 <div className="mt-4 pt-4" style={{color:' #d3d3d3'}}>
                  
                  
                 
//                 </div>
//               </Col>
//               <Col lg="8">
//                 <div className="custom-form mt-4 pt-4">
//                 <p id="error-msg"></p>
//                   <div id="message"></div>
//                   <Form
//                     onSubmit={(e) => {
//                       e.preventDefault();
//                       validation.handleSubmit();
//                       return false;
//                   }}>
//                     <Row>
//                       <Col lg="6 mt-2">
//                       <Input
//                           name="name"
//                           className=""
//                           placeholder="Your name*"
//                           type="text"
//                           onChange={validation.handleChange}
//                           onBlur={validation.handleBlur}
//                           value={validation.values.name || ""}
//                           invalid={
//                               validation.touched.name && validation.errors.name ? true : false
//                           }
//                       />
//                       {validation.touched.name && validation.errors.name ? (
//                           <FormFeedback type="invalid">{validation.errors.name}</FormFeedback>
//                       ) : null}
//                       </Col>
//                       <Col lg="6 mt-2">
//                       <Input
//                             name="email"
//                             className=""
//                             placeholder="Your email*"
//                             type="email"
//                             onChange={validation.handleChange}
//                             onBlur={validation.handleBlur}
//                             value={validation.values.email || ""}
//                             invalid={
//                                 validation.touched.email && validation.errors.email ? true : false
//                             }
//                         />
//                         {validation.touched.email && validation.errors.email ? (
//                             <FormFeedback type="invalid">{validation.errors.email}</FormFeedback>
//                         ) : null}
//                       </Col>
//                     </Row>
//                     <Row>
//                       <Col lg="12 mt-2">
//                       <Input
//                             name="subject"
//                             className=""
//                             placeholder="Your Subject.."
//                             type="text"
//                             onChange={validation.handleChange}
//                             onBlur={validation.handleBlur}
//                             value={validation.values.subject || ""}
//                             invalid={
//                                 validation.touched.subject && validation.errors.subject ? true : false
//                             }
//                         />
//                         {validation.touched.subject && validation.errors.subject ? (
//                             <FormFeedback type="invalid">{validation.errors.subject}</FormFeedback>
//                         ) : null}
//                       </Col>
//                     </Row>
//                     <Row>
//                       <Col lg="12 mt-2">
//                         <div className="form-group">
//                           <textarea
//                             name="comments"
//                             id="comments"
//                             rows="4"
//                             className="form-control"
//                             placeholder="Your message..."
//                           ></textarea>
//                         </div>
//                       </Col>
//                     </Row>
//                     <Row>
//                       <Col lg="12" className="text-end">
//                         <Button className="submitBnt btn btn-primary">
//                           Send Message
//                         </Button>
//                         <div id="simple-msg"></div>
//                       </Col>
//                     </Row>
//                   </Form>
//                 </div>
//               </Col>
//             </Row>
//           </Container>
//         </section>
//       </React.Fragment>
//     );
// }

// export default ContactUs;
